import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {},
  isLoading: false,
  error: null,
  validationErrors: {},
};

const homeFormSlice = createSlice({
  name: 'homeForm',
  initialState,
  reducers: {
    updateHomeFormData: (state, action) => {
      const { formName, data } = action.payload;
      state.formData[formName] = {
        ...state.formData[formName],
        ...data,
      };
    },
    clearHomeFormData: (state, action) => {
      if (action.payload && action.payload.formName) {
        delete state.formData[action.payload.formName];
      } else {
        state.formData = {};
      }
    },
    setHomeFormLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setHomeFormError: (state, action) => {
      state.error = action.payload;
    },
    setHomeValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    clearHomeValidationErrors: (state) => {
      state.validationErrors = {};
    },
    resetHomeForm: (state) => {
      return initialState;
    },
  },
});

export const {
  updateHomeFormData,
  clearHomeFormData,
  setHomeFormLoading,
  setHomeFormError,
  setHomeValidationErrors,
  clearHomeValidationErrors,
  resetHomeForm,
} = homeFormSlice.actions;

// Selectors
export const selectHomeFormData = (state) => state.homeForm.formData;
export const selectHomeFormDataByName = (formName) => (state) => 
  state.homeForm.formData[formName] || {};
export const selectHomeFormLoading = (state) => state.homeForm.isLoading;
export const selectHomeFormError = (state) => state.homeForm.error;
export const selectHomeValidationErrors = (state) => state.homeForm.validationErrors;

export default homeFormSlice.reducer;